// extracted by mini-css-extract-plugin
export default {"category":"Cards_category__BL3kc","text":"Cards_text__7dx7B","cards":"Cards_cards__wQb2i","card":"Cards_card__0FLwi","plus":"Cards_plus__FlY7R"};